import { render, staticRenderFns } from "./TeamGrid.vue?vue&type=template&id=1b788d73&scoped=true"
import script from "./TeamGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamGrid.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TeamGrid.vue?vue&type=style&index=0&id=1b788d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b788d73",
  null
  
)

export default component.exports